import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { Text } from "./index";
export const H = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {Object} props
 * @param {number} [props.level]
 * @param {any} [props.as]
 * @param {any} [props.children]
 * @param {any} [props.className]
 * @param {"light" | "white" | "secondary" | "secondary-white" | "secondary-light" | "primary"} [props.variant]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function H({
  level,
  as,
  children,
  variant,
  className,
  ...props
}, ref) {
  const headingClass = classNames({
    "text-5xl": level === 1,
    "text-4xl": level === 2,
    "text-xl": level === 3,
    "text-base": level === 4,
    "text-sm": level === 5,
    "text-xs uppercase": level === 6,
    "font-bold": level !== 6
  }, ["leading-snug"], className);
  const textVariant = level === 6 ? variant || "light" : variant;
  const el = as || `h${level}`;
  return /*#__PURE__*/React.createElement(Text, _extends({
    className: headingClass,
    variant: textVariant
  }, props, {
    as: el,
    ref: ref
  }), children);
});
H.defaultProps = {
  level: 1
};
H.propTypes = {
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType]),
  level: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  // @ts-ignore
  variant: PropTypes.string
};